import { render, staticRenderFns } from "./QACenterTable.vue?vue&type=template&id=b2399136&scoped=true&"
import script from "./QACenterTable.vue?vue&type=script&lang=js&"
export * from "./QACenterTable.vue?vue&type=script&lang=js&"
import style0 from "./QACenterTable.vue?vue&type=style&index=0&id=b2399136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2399136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VChip,VIcon,VSimpleTable})
